.modalTitle {
	width: 100%;
	margin-right: 15px;
}
.modalHeader {
	border-bottom: 1px solid var(--mantine-color-gray-1);
	@include screen-sm {
		height: auto !important;
	}
}
.modalBody {
	background-color: $background;
}
